import { useStrictLocalization } from "@faire/web/common/localization";
export var useLoggedOutBrandNodes = function useLoggedOutBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var loggedOutBrandNodes = {
    L1: {
      Account: strictLocalize({
        id: "7flPEZ",
        defaultMessage: [{
          "type": 0,
          "value": "Paramètres du compte (par exemple, mise à jour de l'adresse e-mail, informations bancaires)"
        }]
      }),
      Catalog: strictLocalize({
        id: "PewJ+O",
        defaultMessage: [{
          "type": 0,
          "value": "Informations sur le catalogue et la boutique"
        }]
      }),
      Disputes: strictLocalize({
        id: "Sb6ix0",
        defaultMessage: [{
          "type": 0,
          "value": "Litiges"
        }]
      }),
      Invoices: strictLocalize({
        id: "t1H2TU",
        defaultMessage: [{
          "type": 0,
          "value": "Factures et paiements"
        }]
      }),
      Orders: strictLocalize({
        id: "lour39",
        defaultMessage: [{
          "type": 0,
          "value": "Commandes et traitement"
        }]
      }),
      UpdateCommission: strictLocalize({
        id: "9/FL8z",
        defaultMessage: [{
          "type": 0,
          "value": "Mettre à jour la commission/relation"
        }]
      }),
      GeneralShipping: strictLocalize({
        id: "ueCCEa",
        defaultMessage: [{
          "type": 0,
          "value": "Questions générales sur l'expédition"
        }]
      }),
      Other: strictLocalize({
        id: "anUKfs",
        defaultMessage: [{
          "type": 0,
          "value": "Autres questions relatives aux marques"
        }]
      })
    },
    L2: {
      SWF: strictLocalize({
        id: "xc/zXa",
        defaultMessage: [{
          "type": 0,
          "value": "Expédier avec Faire"
        }]
      }),
      SOYO: strictLocalize({
        id: "R22FJg",
        defaultMessage: [{
          "type": 0,
          "value": "Expédier par vous-même"
        }]
      }),
      SellingInternational: strictLocalize({
        id: "vNJE8v",
        defaultMessage: [{
          "type": 0,
          "value": "Vendre à l'international"
        }]
      }),
      Other: strictLocalize({
        id: "+c3AoM",
        defaultMessage: [{
          "type": 0,
          "value": "Autres questions"
        }]
      })
    },
    L3: {
      Availability: strictLocalize({
        id: "UaBkUO",
        defaultMessage: [{
          "type": 0,
          "value": "L'option Expédier avec Faire est-elle disponible dans mon pays ?"
        }]
      }),
      LabelIssues: strictLocalize({
        id: "1HdGkw",
        defaultMessage: [{
          "type": 0,
          "value": "Problèmes d'étiquette"
        }]
      }),
      Costs: strictLocalize({
        id: "oQXdAP",
        defaultMessage: [{
          "type": 0,
          "value": "Coûts"
        }]
      }),
      Others: strictLocalize({
        id: "IwX/dA",
        defaultMessage: [{
          "type": 0,
          "value": "Autres"
        }]
      }),
      HowTo: strictLocalize({
        id: "ayEfYp",
        defaultMessage: [{
          "type": 0,
          "value": "Instructions"
        }]
      })
    }
  };
  return loggedOutBrandNodes;
};